class Product{constructor(){this.acc=[],this.container=document.querySelector(".m-main-product"),MinimogTheme.CompareProduct&&MinimogTheme.CompareProduct.setCompareButtonsState(),MinimogTheme.Wishlist&&MinimogTheme.Wishlist.setWishlistButtonsState(),this.addRecentViewedProduct(),addEventDelegate({context:this.container,selector:(window.__minimog_review_selector||"")+".m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview",handler:e=>{const t=e.target.closest(".m-product-collapsible").dataset.index;setTimeout((()=>{this.acc[Number(t)].setContentHeight()}),300)},capture:!0})}addRecentViewedProduct(){const e=getCookie("m-recent-viewed-products");let t=e?JSON.parse(e):[];-1===t.indexOf(MinimogSettings.productHandle)&&(t.unshift(MinimogSettings.productHandle),t=t.slice(0,20),setCookie("m-recent-viewed-products",JSON.stringify(t)))}}

(function () {
  // Guard the legacy product-form observer against observing mutations caused by its own callback.
  // This targets only observers using the exact childList + subtree + characterData pattern on .m-product-form.
  if (!window.__djProductFormMutationGuardInstalled && window.MutationObserver) {
    window.__djProductFormMutationGuardInstalled = true;

    var NativeMutationObserver = window.MutationObserver;

    window.MutationObserver = function(callback) {
      var watched = [];
      var guarded = false;
      var observer;

      observer = new NativeMutationObserver(function(records, nativeObserver) {
        if (!guarded) {
          callback(records, nativeObserver);
          return;
        }

        nativeObserver.disconnect();
        try {
          callback(records, nativeObserver);
        } finally {
          watched.forEach(function(entry) {
            nativeObserve(entry.target, entry.options);
          });
        }
      });

      var nativeObserve = observer.observe.bind(observer);
      var nativeDisconnect = observer.disconnect.bind(observer);

      observer.observe = function(target, options) {
        watched.push({ target: target, options: options });

        if (
          target &&
          target.matches &&
          target.matches('.m-product-form') &&
          options &&
          options.childList === true &&
          options.subtree === true &&
          options.characterData === true
        ) {
          guarded = true;
        }

        nativeObserve(target, options);
      };

      observer.disconnect = function() {
        watched = [];
        guarded = false;
        nativeDisconnect();
      };

      return observer;
    };

    window.MutationObserver.prototype = NativeMutationObserver.prototype;
    try { Object.setPrototypeOf(window.MutationObserver, NativeMutationObserver); } catch (e) {}
  }

  function ensureNote(card, text) {
    if (!card) return;

    var note = card.querySelector('.dj-product-purchase-note');
    if (!note) {
      note = document.createElement('div');
      note.className = 'dj-product-purchase-note';
      card.appendChild(note);
    }
    note.textContent = text;
  }

  function getCurrentVariantData() {
    var dataEl = document.getElementById('productData');
    var productData = null;

    if (dataEl) {
      try {
        productData = JSON.parse(dataEl.textContent || '{}');
      } catch (e) {
        productData = null;
      }
    }

    var variantId = '';
    var variantInput = document.querySelector('.m-product-form input[name="id"]');
    if (variantInput && variantInput.value) {
      variantId = String(variantInput.value);
    }

    if (!variantId) {
      variantId = new URLSearchParams(window.location.search).get('variant') || '';
    }

    var variant = null;
    if (productData && Array.isArray(productData.variants)) {
      if (variantId) {
        variant = productData.variants.find(function (item) {
          return String(item.id) === String(variantId);
        }) || null;
      }
      if (!variant) {
        variant = productData.variants[0] || null;
      }
    }

    return {
      productData: productData,
      variant: variant
    };
  }

  function updateFinanceLinks() {
    document.querySelectorAll('.dj-product-purchase-button--online').forEach(function (link) {
      var productRoot = link.closest('.m-main-product') || document.querySelector('.m-main-product');
      var handle = productRoot && productRoot.dataset ? (productRoot.dataset.productHandle || '') : '';
      if (!handle) return;

      var current = getCurrentVariantData();
      var variant = current.variant;
      var productData = current.productData;

      var oldUrl;
      try {
        oldUrl = new URL(link.href, window.location.origin);
      } catch (e) {
        oldUrl = new URL(window.location.origin + '/');
      }

      var variantId = variant && variant.id ? String(variant.id) : (oldUrl.searchParams.get('variant') || '');
      var sku = variant && variant.sku ? String(variant.sku) : (oldUrl.searchParams.get('sku') || '');
      var title = productData && productData.title ? String(productData.title) : (oldUrl.searchParams.get('title') || '');

      var params = new URLSearchParams();
      params.set('handle', handle);
      if (variantId) params.set('variant', variantId);
      if (sku) params.set('sku', sku);
      if (title) params.set('title', title);

      var encoded = params.toString();
      link.href = 'https://apply.jewelermodesto.com/financing-app?' + encoded + '#' + encoded;
    });
  }

  function applyDeAngelosProductPolish() {
    document.querySelectorAll('.dj-product-purchase-heading').forEach(function (heading) {
      heading.textContent = 'Other ways to purchase';
    });

    document.querySelectorAll('.dj-product-finance-details').forEach(function (details) {
      var text = details.textContent || '';
      var paymentMatch = text.match(/\$[\d,.]+\/month/);

      if (paymentMatch) {
        details.innerHTML =
          '<strong>25% down payment required</strong><br>' +
          'Estimated monthly payment: about ' + paymentMatch[0] + '<br>' +
          '<span class="dj-product-finance-note">Final payment terms are reviewed before you sign.</span>';
      }
    });

    document.querySelectorAll('.dj-product-purchase-card--ca').forEach(function (card) {
      var title = card.querySelector('.dj-product-purchase-title');
      var body = card.querySelector('.dj-product-purchase-text');
      var link = card.querySelector('.dj-product-purchase-button--ca');

      if (title) title.textContent = 'Work directly with our jewelry team';
      if (body) body.textContent = 'Get one-on-one help with your jewelry, purchase, and financing directly from our team.';
      if (link && link.getAttribute('href') === '/pages/contact') link.textContent = 'CONTACT OUR STORE';

      ensureNote(card, 'Available for California purchases.');
    });

    document.querySelectorAll('.dj-product-purchase-card--online').forEach(function (card) {
      var eyebrow = card.querySelector('.dj-product-purchase-eyebrow');
      var title = card.querySelector('.dj-product-purchase-title');

      if (eyebrow) eyebrow.textContent = 'FINANCE ONLINE';
      if (title) title.textContent = 'Complete your financing from home';

      ensureNote(card, 'Available for eligible purchases outside California.');
    });

    updateFinanceLinks();

    document.querySelectorAll('#customFormRedirect').forEach(function (button) {
      var wrapper = button.closest('.ext-checkout');
      if (wrapper) {
        wrapper.remove();
      } else {
        button.remove();
      }
    });

    document.querySelectorAll('.main-product__block-buy_buttons .acan a').forEach(function (link) {
      link.textContent = 'Save when paying with Zelle';
      link.classList.remove('m-button--primary', 'ctabutton');
      link.classList.add('dj-zelle-button');
    });

    document.querySelectorAll('.main-product__block-emi .sku-container').forEach(function (sku) {
      sku.remove();
    });

    document.querySelectorAll('.main-product__block-design_expert_cta').forEach(function (helpBlock) {
      helpBlock.remove();
    });

    if (!document.getElementById('dj-product-polish-styles')) {
      const style = document.createElement('style');
      style.id = 'dj-product-polish-styles';
      style.textContent = `
        .dj-product-purchase-note {
          margin-top: 9px;
          color: #6d6d6d;
          font-size: 11px;
          line-height: 1.45;
        }
        .dj-product-finance-note {
          color: #666666;
          font-size: 12px;
        }
        .main-product__block-buy_buttons .acan {
          margin-top: 10px;
          text-align: center;
        }
        .main-product__block-buy_buttons .dj-zelle-button {
          display: inline-block;
          width: auto !important;
          max-width: 100%;
          background: transparent !important;
          color: #9a3a31 !important;
          border: 1px solid #d8b5b0 !important;
          padding: 9px 14px !important;
          font-size: 13px !important;
          font-weight: 600;
          line-height: 1.25;
          text-align: center;
          text-decoration: none;
          box-sizing: border-box;
          border-radius: 4px;
        }
        .main-product__block-buy_buttons .dj-zelle-button:hover {
          background: #fff9f7 !important;
          color: #873129 !important;
          border-color: #c89189 !important;
        }
        @media screen and (max-width: 767px) {
          .m-product-recommendations .swiper-slide {
            width: 72vw !important;
            max-width: 320px;
          }
          .m-product-recommendations .m-product-card__name {
            -webkit-line-clamp: 2;
            line-clamp: 2;
          }
          .m-product-recommendations .m-product-card__info {
            margin-top: 10px;
          }
        }
        @media screen and (min-width: 768px) and (max-width: 1100px) {
          .m-product-recommendations .swiper-slide {
            width: 42vw !important;
            max-width: 400px;
          }
          .m-product-recommendations .m-product-card__name {
            -webkit-line-clamp: 2;
            line-clamp: 2;
          }
        }
      `;
      document.head.appendChild(style);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDeAngelosProductPolish);
  } else {
    applyDeAngelosProductPolish();
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('.m-main-product')) {
      setTimeout(updateFinanceLinks, 50);
    }
  });

  document.addEventListener('shopify:section:load', applyDeAngelosProductPolish);
})();